import React, { useEffect, useState } from 'react'
import {
  CFormTextarea,
  CCard,
  CButton,
  CSpinner,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CCardBody,
  CFormInput,
  CFormLabel,
  CForm,
  CRow,
  CCol,
  CTable,
  CTableBody,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CTableDataCell,
} from '@coreui/react'
import Carder from '../../components/shared/Carder'
import { toastConfig } from '../../constants/other.config'
import toast from 'react-hot-toast'
import GetPatientAllergiesCRUD from '../../services/general/getPatientAllergies.api'
import CustomDatePickingFormat from '../../../src/components/shared/CustomDatePickingFormat'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

const PatientAllergies = ({ patientID, loading, setLoading, saveTreatsShell, allergiesList, setAllergiesList, noteStructureRef }) => {
  const getFormattedDateUsFormat = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    return `${mm}/${dd}/${yyyy}`
  }
  const [modalVisible, setModalVisible] = useState(false)
  const [allergyEditId, setAllergyEditId] = useState(null)
  const [waiter, setWaiter] = useState(false)
  const [allergy, setAllergy] = useState({
    allergen: '',
    severity: '',
    reaction: '',
    dateOfOnset: getFormattedDateUsFormat(),
    updated: '',
  })
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [editableAllergiesId, setEditableAllergiesId] = useState([])
  const [errors, setErrors] = useState({})

  const [showEditHtml, setShowEditHtml] = useState(false)
  const [tempHtmlContent, setTempHtmlContent] = useState('')

  useEffect(() => {
    fetchAllergies()
  }, [patientID])

  const handleAllergyChange = (e) => {
    const { name, value } = e.target
    setAllergy((prevAllergy) => ({
      ...prevAllergy,
      [name]: value,
    }))
  }

  const fetchAllergies = async () => {
    try {
      let formattedData
      let withoutSorted
      formattedData = await GetPatientAllergiesCRUD('GET', patientID)
      formattedData = JSON.parse(formattedData.d)
      formattedData = formattedData?.Data || []
      if (formattedData) {
        withoutSorted = formattedData?.map((item) => {
          return {
            ...item,
            data: JSON.parse(item.data),
          }
        })
        formattedData = formattedData?.map((item) => {
          return {
            ...item,
            data: JSON.parse(item.data),
          }
        })
      }
      formattedData.sort((a, b) => new Date(b?.date) - new Date(a?.date))
      setAllergiesList(formattedData)
      return withoutSorted
    } catch (error) {
      console.log(error)
      toast.error('Error fetching allergies', toastConfig)
    }
  }

  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`
  }

  const handleAddAllergy = async () => {
    // Validate dateOfOnset
    const newErrors = {}
    if (!allergy.dateOfOnset) {
      newErrors.dateOfOnset = 'Date of Onset is required'
    }
    setErrors(newErrors)
    
    if (Object.keys(newErrors).length > 0) {
      return
    }
    
    setWaiter(true)
    try {
      if (allergyEditId !== null) {
        await GetPatientAllergiesCRUD('UPDATE', patientID.toString(), JSON.stringify(allergy), allergyEditId.toString())
        setModalVisible(false)
        setErrors({})
        setAllergyEditId(null)
        setAllergy({
          allergen: '',
          severity: '',
          reaction: '',
          dateOfOnset: '',
          updated: '',
        })
        await fetchAllergies()
        toast.success('Successfully Updated', toastConfig)
      } else {
        await GetPatientAllergiesCRUD('INSERT', patientID.toString(), JSON.stringify(allergy), '', getFormattedDate())
        setModalVisible(false)
        setErrors({})
        setAllergy({
          allergen: '',
          severity: '',
          reaction: '',
          dateOfOnset: '',
          updated: '',
        })
        const allAllergies = await fetchAllergies()
        if (allAllergies.length > 0) {
          const lastAllergyId = allAllergies[allAllergies.length - 1]?.id

          if (lastAllergyId) {
            const existingIds = noteStructureRef.current?.metadata?.allergiesIds || []

            const updatedIds = [...new Set([...existingIds, lastAllergyId])]

            noteStructureRef.current = {
              ...noteStructureRef.current,
              metadata: {
                ...noteStructureRef.current?.metadata,
                allergiesIds: updatedIds,
              },
            }

            setEditableAllergiesId(updatedIds)
          }
        }
        toast.success('Successfully Added', toastConfig)
        await saveTreatsShell(false)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setWaiter(false)
    }
  }

  const handleEditAllergies = (allergy) => {
    setModalVisible(true)
    setAllergy(allergy.data)
    setAllergyEditId(allergy.id)
  }

  const handleDeleteAllergies = async (id) => {
    await GetPatientAllergiesCRUD('DELETE', patientID.toString(), '', deleteVisibleId?.toString())
    await fetchAllergies()
    setDeleteVisibleId(null)
  }

  useEffect(() => {
    const allAllergiesIdsEditable = noteStructureRef.current?.metadata?.allergiesIds || []
    setEditableAllergiesId(allAllergiesIdsEditable || [])
  }, [])

  return (
    <>
      <CButton style={{ marginTop: '10px' }} onClick={() => setModalVisible(true)} variant="outline" color="primary" className="patient-page-action-btn">
        + Add Allergy
      </CButton>

      {/* delete modal */}
      <CModal visible={deleteVisibleId}>
        <CModalHeader>
          <CModalTitle>Warning</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
        </CModalBody>
        <hr className="p-0 m-0" />
        <CModalFooter className="p-3 m-0">
          <CButton
            onClick={() => {
              setDeleteVisibleId(null)
            }}
            className="text-white"
            color="secondary"
          >
            Close
          </CButton>
          <CButton onClick={handleDeleteAllergies} className="text-white" color="danger">
            Delete
          </CButton>
        </CModalFooter>
      </CModal>

      {allergiesList.length > 0 && editableAllergiesId.length > 0 ? (
        allergiesList
          .filter((allergy) => editableAllergiesId.includes(allergy.id))
          .map((allergy, index) => (
            <Carder
              editFunc={
                editableAllergiesId.includes(allergy.id)
                  ? () => {
                      handleEditAllergies(allergy)
                    }
                  : null
              }
              deleteFunc={
                editableAllergiesId.includes(allergy.id)
                  ? () => {
                      setDeleteVisibleId(allergy.id)
                    }
                  : null
              }
              key={index}
              style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }}
              className="mt-3"
            >
              <CCardBody>
                <b>
                  <div className="mb-3">
                    Date:{' '}
                    {new Date(allergy.date).toLocaleDateString('en-US', {
                      month: '2-digit',
                      day: '2-digit',
                      year: 'numeric',
                    })}
                  </div>
                </b>
                <CTable>
                  <CTableBody>
                    <CTableRow>
                      <CTableHeaderCell style={{ width: '50%' }}>Allergen</CTableHeaderCell>
                      <CTableDataCell style={{ width: '50%' }}>{allergy.data?.allergen}</CTableDataCell>
                    </CTableRow>
                    <CTableRow>
                      <CTableHeaderCell style={{ width: '50%' }}>Severity</CTableHeaderCell>
                      <CTableDataCell style={{ width: '50%' }}>{allergy.data?.severity}</CTableDataCell>
                    </CTableRow>
                    <CTableRow>
                      <CTableHeaderCell style={{ width: '50%' }}>Reaction</CTableHeaderCell>
                      <CTableDataCell style={{ width: '50%' }}>{allergy.data?.reaction}</CTableDataCell>
                    </CTableRow>
                    <CTableRow>
                      <CTableHeaderCell style={{ width: '50%' }}>Date of Onset</CTableHeaderCell>
                      <CTableDataCell style={{ width: '50%' }}>{new Date(allergy.data?.dateOfOnset).toLocaleDateString('en-US')}</CTableDataCell>
                    </CTableRow>
                  </CTableBody>
                </CTable>
              </CCardBody>
            </Carder>
          ))
      ) : (
        <div className="text-center text-muted mt-3">Patient Has No Allergies</div>
      )}
      {noteStructureRef?.current?.freeTypesEverything?.allergiesFreetype && (
        <div className="mt-2">
          <hr className="hr-text" data-content="Old Allergies" />

          <div
            className="p-4"
            style={{ background: '#f6f6f6ff', borderRadius: '10px' }}
            onClick={() => {
              setTempHtmlContent(noteStructureRef?.current?.freeTypesEverything?.allergiesFreetype || '')
              // setShowEditHtml(true)
            }}
            dangerouslySetInnerHTML={{ __html: noteStructureRef?.current?.freeTypesEverything?.allergiesFreetype }}
          ></div>
        </div>
      )}
      <CModal className="dashboard-dark-modal patient-theme-modal patient-labs-modal" size="lg" scrollable backdrop={'static'} visible={modalVisible} onClose={() => {
        setModalVisible(false)
        setErrors({})
      }}>
        <CModalHeader onClose={() => {
          setModalVisible(false)
          setErrors({})
        }}>
          <CModalTitle>Add Patient Allergy</CModalTitle>
        </CModalHeader>
        <CModalBody style={{ height: '500px' }}>
          <CForm>
            <CRow className="mb-3">
              <CCol xs="6">
                <CFormLabel>Allergen</CFormLabel>
                <CFormInput type="text" name="allergen" value={allergy.allergen} onChange={handleAllergyChange} />
              </CCol>
              <CCol xs="6">
                <CFormLabel>Severity</CFormLabel>
                <CFormInput type="text" name="severity" value={allergy.severity} onChange={handleAllergyChange} />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol xs="6">
                <CFormLabel>Reaction</CFormLabel>
                <CFormInput type="text" name="reaction" value={allergy.reaction} onChange={handleAllergyChange} />
              </CCol>
              <CCol xs="6" className="d-flex flex-column">
                <CFormLabel>Date of Onset</CFormLabel>
                {/* <CFormInput
                                    type="date"
                                    name="dateOfOnset"
                                    value={allergy.dateOfOnset}
                                    onChange={handleAllergyChange}
                                /> */}

                <CustomDatePickingFormat
                  className=""
                  value={allergy.dateOfOnset}
                  onChange={(e) => {
                    setAllergy((p) => ({
                      ...p,
                      dateOfOnset: e,
                    }))
                    // Clear error when user starts typing
                    if (errors.dateOfOnset) {
                      setErrors((prev) => ({ ...prev, dateOfOnset: '' }))
                    }
                  }}
                  format="mm-dd-yyyy"
                />
                {errors.dateOfOnset && <small style={{ color: '#dc3545', marginTop: '4px' }}>{errors.dateOfOnset}</small>}
              </CCol>
            </CRow>
          </CForm>
        </CModalBody>
        <CModalFooter>
          <CButton color="primary" variant="outline" onClick={handleAddAllergy} className="patient-page-action-btn">
            {waiter ? (
              <CSpinner component="span" size="sm" aria-hidden="true" />
            ) : (
              <>{allergyEditId !== null ? 'Update Allergy' : 'Add Allergy'}</>
            )}
          </CButton>
          <CButton variant="outline" color="secondary" className="patient-page-action-btn" onClick={() => {
            setModalVisible(false)
            setErrors({})
          }}>
            Cancel
          </CButton>
        </CModalFooter>
      </CModal>
      <CModal size="lg" visible={showEditHtml} onClose={() => setShowEditHtml(false)} aria-labelledby="OptionalSizesExample2">
        <CModalHeader>
          <CModalTitle id="OptionalSizesExample2">Edit Allergies Free Type</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Editor
            onChange={(e) => {
              setTempHtmlContent(e.target.value)
            }}
            containerProps={{
              style: {
                width: '100%',
                background: '#f9f9f9',
                border: 0,
                height: '100%',
                minHeight: 'unset',
              },
            }}
            value={tempHtmlContent}
          >
            <tooltip />
          </Editor>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setShowEditHtml(false)}>
            Close
          </CButton>
          <CButton
            variant="outline"
            color="primary"
            onClick={() => {
              noteStructureRef.current = {
                ...noteStructureRef.current,
                freeTypesEverything: {
                  ...noteStructureRef.current?.freeTypesEverything,
                  allergiesFreetype: tempHtmlContent,
                },
              }
              saveTreatsShell(false)
              setShowEditHtml(false)
            }}
          >
            Save Changes
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default PatientAllergies
